import React from 'react'
import { Trans } from '@lingui/macro'

import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Link from '@mui/material/Link'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import { useConnectorDownload } from '../model/useConnectorDownload'

/**
 * Download entry point for the local device connector. The package is resolved
 * from the published release manifest rather than a hardcoded URL, so a new
 * release reaches users without a frontend deploy.
 */
export function ConnectorDownloadButton() {
  const { platform, url, zipUrl, version, isLoading, isUnavailable } = useConnectorDownload()

  if (platform === 'unsupported') {
    return (
      <Alert severity="info" sx={{ mb: 2 }}>
        <Trans>The local device connector is available for Windows and macOS only.</Trans>
      </Alert>
    )
  }

  if (isUnavailable) {
    return (
      <Alert severity="warning" sx={{ mb: 2 }}>
        <Trans>No connector release is available for your operating system yet.</Trans>
      </Alert>
    )
  }

  return (
    <Stack spacing={1} sx={{ mb: 2 }} alignItems="flex-start">
      <Button variant="contained" color="primary" href={url ?? ''} disabled={isLoading || !url} target="_blank" rel="noopener noreferrer">
        <Trans>Download the last version of the Medconnect program</Trans>
      </Button>

      {version && (
        <Typography variant="caption" color="text.secondary">
          <Trans>Version {version}</Trans>
        </Typography>
      )}

      {zipUrl && (
        <Link href={zipUrl} target="_blank" rel="noopener noreferrer" variant="caption">
          <Trans>Download the .zip archive instead</Trans>
        </Link>
      )}
    </Stack>
  )
}
